module.exports = __webpack_public_path__ + "static/img/mhaibao2.619ae68.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/mhaibao2.png
// module id = fsHL
// module chunks = 0